<template>
  <div class="custom-container" v-loading.fullscreen.lock="order.isLoading">
    <el-container class="category-title my-2">Order Details &nbsp; <b> {{ order.data.orderId }} </b></el-container>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" shadow="never">
          <el-row type="flex" justify="space-between" align="middle">
            <el-col>
              <el-tag
                v-if="order.data.orderStatus === 'payment_confirmation'"
                type="dark"
                effect="dark"
              >Menunggu Pembayaran</el-tag>
              <el-tag
                v-else-if="order.data.orderStatus === 'on_progress'"
                type="info"
                effect="dark"
              >Dalam Proses</el-tag>
              <el-tag
                v-else-if="order.data.orderStatus === 'delivery'"
                type="warning"
                effect="dark"
              >Dalam Pengiriman</el-tag>
              <el-tag
                v-else-if="order.data.orderStatus === 'done'"
                type="success"
                effect="dark"
              >Selesai</el-tag>
              <el-tag type="dark" effect="dark">{{order.data.branchCodeData}}</el-tag>
            </el-col>
            <el-tag v-if="order.data.orderCreatedAt">
              {{
              order.data.orderCreatedAt
              }}
            </el-tag>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mt-4">
      <el-col :lg="24" :md="24">
        <el-card class="box-card mb-2" shadow="never">
          <span style="font-size: 16px; font-weight: bold">Items</span>
          <el-table :data="order.data.orderDetail" border>
            <el-table-column width="50" type="index" label="No">
              <template #default="scope">
                {{ calculateRowNumber(scope.$index) }}
              </template>
            </el-table-column>
            <el-table-column width="180" prop="itemName" label="Item"></el-table-column>
            <el-table-column
              width="130"
              align="right"
              header-align="left"
              prop="itemPrice"
              label="Price"
            ></el-table-column>
            <el-table-column prop="qty" label="Qty"></el-table-column>
            <el-table-column
              width="130"
              align="right"
              header-align="left"
              prop="netPrice"
              label="Net Price"
            ></el-table-column> <!--label="Total"-->
            <el-table-column
              v-if="branch === 'staging'"
              width="130"
              align="right"
              header-align="left"
              prop="discountAmount"
              label="Discount Amount"
            ></el-table-column>
            <el-table-column v-if="branch === 'staging'" width="180" prop="amtAfterDiscount" label="Total After Discount"></el-table-column>
            <el-table-column v-if="branch === 'staging'"  label="Potongan" align="center">
              <el-table-column width="150" prop="totalPromoLines" label="Promo Item"></el-table-column>
              <el-table-column width="150" prop="totalPromoStrata" label="Strata"></el-table-column>
              <el-table-column width="150" prop="totalPromoVoucher" label="Voucher"></el-table-column>
            </el-table-column>
            <el-table-column prop="uomCode" label="UOM"></el-table-column>
            <el-table-column prop="ppn" label="PPN"></el-table-column>
            <!-- <el-table-column
              width="180"
              prop="taxAmount"
              label="Tax Amount"
            ></el-table-column
            >-->
          </el-table>
          <el-row class="mt-4">
            <el-col :span="17" style="text-align: right">Sub Total :</el-col>
            <el-col :span="7" style="text-align: right">
              {{ order.data.subTotal }} 
            </el-col>
          </el-row>

          
          <el-row v-for="(discount, idx) in order.data.discount" :key="idx">
            <el-col :span="17" style="text-align: right">
              <span v-if="discount.discountType !== 'voucher'">{{ discount.description }} :</span>
             <a v-if="discount.discountType === 'voucher'" @click="handleClick(discount.discountId)" target="_blank" rel="noopener noreferrer">{{ discount.description }} :</a> </el-col>
            <el-col :span="7" style="text-align: right">
              {{ discount.discAmount }}
            </el-col>
          </el-row>

          <!-- sementara komen ini dulu </el-row>
          <el-row v-if="titlePromoCart !== '-'"> // bagian in kemungkinan jadi dobel saat di form hasil orderannya (dengan promo)
            <el-col :span="17" style="text-align: right">{{ order.data.titlePromoCart }} :</el-col>
            <el-col :span="7" style="text-align: right">
              {{ order.data.totalPromoCart }}
            </el-col>
          </el-row>
          -->

          <el-row>
            <el-col :span="17" style="text-align: right">Sub Total Setelah Promo :</el-col>
            <el-col :span="7" style="text-align: right">
              {{ order.data.subTotalAfterPromo }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="17" style="text-align: right">Tax Rate :</el-col>
            <el-col :span="7" style="text-align: right">
              {{
              order.data.taxRate
              }}
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="17" style="text-align: right">Discount 95+ :</el-col>
            <el-col :span="7" style="text-align: right">Rp. 2.000.000</el-col>
          </el-row>-->
          <!-- <el-row>
            <el-col :span="17" style="text-align: right">Discount 25+ :</el-col>
            <el-col :span="7" style="text-align: right">Rp. 250.000</el-col>
          </el-row>-->
          <el-row>
            <el-col :span="17" style="text-align: right">Total :</el-col>
            <el-col :span="7" style="text-align: right">
              {{
              order.data.total
              }}
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="text-align: right">
        <el-pagination
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          :total="order.data.countOrderDetail"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 50]"
        />
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mt-4">
      <el-col :lg="12" :md="12">
        <el-card v-if="branch === 'staging'" class="mb-2" shadow="never">
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold">Payment</span>
          </el-row>
          <el-row class="mb-2">
            <el-col :span="7">Payment Method</el-col>
            <el-col :span="1">
              <span>:</span>
            </el-col>
            <el-col :span="16">{{ order.data.paymentCode }}</el-col>
          </el-row>
          <el-row>
            <el-form label-position="left" ref="formOrders" :model="formOrders" label-width="120px">
              <el-row type="flex" align="middle" class="mb-2">
                <el-col :span="7">
                  <span>Payment Value</span>
                </el-col>
                <el-col :span="1">
                  <span>:</span>
                </el-col>
                <el-col :span="16">{{ order.data.paymentValue }}</el-col>
              </el-row>
              <el-row type="flex" align="middle" class="mb-2">
                <el-col :span="7">
                  <span class="demo-input-label">Payment Amount</span>
                </el-col>
                <el-col :span="1">
                  <span>:</span>
                </el-col>
                <el-col :span="16">{{ order.data.paymentAmount }}</el-col>
              </el-row>
              <el-row type="flex" align="middle" class="mb-2">
                <el-col :span="7">
                  <span class="demo-input-label">Payment Note</span>
                </el-col>
                <el-col :span="1">
                  <span>:</span>
                </el-col>
                <el-col :span="16">{{ order.data.paymentNote }}</el-col>
              </el-row>
              <el-row type="flex" class="mb-2">
                <el-col :span="7">
                  <span class="demo-input-label">Bukti Transfer</span>
                </el-col>
                <el-col :span="1">
                  <span>:</span>
                </el-col>
                <el-col :span="16">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="order.data.imageBuktiTransfer"
                    :preview-src-list="[order.data.imageBuktiTransfer]"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </el-col>
              </el-row>

              <el-button
                v-if="order.data.paymentCode !== 'COD' && order.data.paymentCode !== 'TOP'"
                @click="save"
                class="mt-4"
                type="primary"
                size="small"
                style="width: 100%"
                :disabled="
                  order.data.orderStatus == 'on_progress' ||
                    order.data.orderStatus == 'delivery' ||
                    order.data.orderStatus == 'done'
                "
              >Accept Payment</el-button>
            </el-form>
          </el-row>
        </el-card>
        <el-card class="mb-2" shadow="never">
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold;">Shipping Address</span>
          </el-row>
          <el-row v-if="order.data.ship_to">
            <template v-for="(value, name, index) in shippingAddress">
              <el-col :span="7" :key="index">{{ value }}</el-col>
              <el-col :span="1" :key="index + value">
                <span>:</span>
              </el-col>
              <el-col :span="16" :key="value">
                {{
                order.data.ship_to[name] || "-"
                }}
              </el-col>
            </template>
          </el-row>
        </el-card>
        <el-card class="mb-2" shadow="never">
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold;">Billng Address</span>
          </el-row>
          <el-row v-if="order.data.bill_to">
            <template v-for="(value, name, index) in billAddress">
              <el-col :span="7" :key="index">{{ value }}</el-col>
              <el-col :span="1" :key="index + value">
                <span>:</span>
              </el-col>
              <el-col :span="16" :key="value">
                {{
                order.data.bill_to[name] || "-"
                }}
              </el-col>
            </template>
          </el-row>
        </el-card>
        <el-card v-if="branch === 'staging'" class="mb-2" shadow="never">
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold;">Shipping</span>
          </el-row>
          <el-row>
            <template v-for="(value, name, index) in shipping">
              <el-col :span="7" :key="index">{{ value }}</el-col>
              <el-col :span="1" :key="index + value">
                <span>:</span>
              </el-col>
              <el-col :span="16" :key="value">
                {{
                order.data.shipping && order.data.shipping[name]
                }}
              </el-col>
            </template>
          </el-row>
        </el-card>
      </el-col>

      <el-col :lg="12" :md="12">
        <el-card
          v-if="
            order.data.paymentCode &&
              order.data.paymentCode.substring(0, 3) === 'COD'
          "
          class="mb-2"
          shadow="never"
          style="text-align: center;"
        >
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold;">QR Code</span>
          </el-row>
          <el-button
              @click="getQr('COD')"
              class="mt-4"
              type="primary"
              size="small"
              style="width: 350px ; width: 160px; font-size: 16px; border-radius: 10px;"
              :loading="qrCode.isLoading"
              :disabled="disabledBtnQr"
            >
            <img v-if="!qrCode.isLoading" src="../../assets/qr.png" style="width: 16px; height: 16px;" />
              {{
              conditionBtn === "view" ? "Show Qr Code" : "Reload Qr Code"
              }}
            </el-button>
          <el-row style="width: 100%">
            <el-row v-if="!conditionQr">
              <el-col style="display: flex; align-items: center;justify-content: center;">
                <el-card class="qrCodeNotAvailable" shadow="never">{{ qrCode.data }}</el-card>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col style="display: flex; align-items: center;justify-content: center; margin-top: 10px;">
                <!-- <img v-if="blur" src="../../assets/blurQr.png" style="width: 350px; height: 350px;" /> -->
                <qr-code v-if="!blur" :text="qrCode.data" :size="350"></qr-code>
              </el-col>
            </el-row>

          </el-row>
        </el-card>
        <el-card
          v-if="
            order.data.paymentCode &&
              order.data.paymentCode.substring(0, 3) === 'TOP'
          "
          class="mb-2"
          shadow="never"
          style="text-align: center;"
        >
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold;">QR Code</span>
          </el-row>
          <el-button
              @click="getQr('TOP')"
              class="mt-4"
              type="primary"
              size="small"
              style="width: 160px; font-size: 16px; border-radius: 10px;"
              :loading="qrCode.isLoading"
              :disabled="disabledBtnQr"
            >
            <img v-if="!qrCode.isLoading" src="../../assets/qr.png" style="width: 16px; height: 16px;" />
              {{
              conditionBtn === "view" ? "Show Qr Code" : "Reload Qr Code"
              }}
            </el-button>
          <el-row style="width: 100%;">
            <el-row v-if="!conditionQr">
              <el-col style="display: flex; align-items: center;justify-content: center;">
                <el-card class="qrCodeNotAvailable" shadow="never">{{ qrCode.data }}</el-card>
              </el-col>
            </el-row>
            <el-row v-else>
              <!-- <img v-if="blur" src="../../assets/blurQr.png" style="width: 350px; height: 350px;" /> -->
              <qr-code v-if="!blur" :text="qrCode.data" :size="350"></qr-code>
            </el-row>

          </el-row>
        </el-card>
      </el-col>
      
      
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["oracleCustomerId", "orderId"],
  components: {},
  data: () => ({
    blur: true,
    conditionBtn: "view",
    conditionQr: true,
    disabledBtnQr: false,
    formOrders: {
      paymentValue: "",
      paymentNote: "",
      attachment: ""
    },
    modeShow: false,
    valid: true,
    itemsStatus: [
      { label: "Waiting for Payment", value: 0 },
      { label: "Pending", value: 1 },
      { label: "Shipping", value: 2 },
      { label: "Delivered", value: 3 },
      { label: "Rejected", value: 4 }
    ],
    image: null,
    shippingAddress: {
      country: "Country",
      province: "Province",
      city: "City",
      state: "State",
      address: "Address",
      postal_code: "Postal Code",
      phone_number: "Phone Number",
      contact_person: "Contact Person",
      contact_phone_number: "CP Contact"
    },
    billAddress: {
      country: "Country",
      province: "Province",
      city: "City",
      state: "State",
      address: "Address",
      postal_code: "Postal Code",
      phone_number: "Phone Number",
      contact_person: "Contact Person",
      contact_phone_number: "CP Contact"
    },
    shipping: {
      estimateArrival: "Estimate Arrival",
      status: "Status"
    },
    branch: 'development',
    pagination: {
      currentPage: 1,
      pageSize: 10,
    },
  }),
  computed: {
    ...mapState({
      order: state => state.order.order,
      qrCode: state => state.order.qrCode
    })
  },
  methods: {
    ...mapActions({
      getOrder: "order/GetOrder",
      updateOrder: "order/UpdateOrder",
      getQrCode: "order/GetQrCode"
    }),
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.image = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.formOrders.attachment = files["0"];
    },
    save() {
      this.$refs.formOrders.validate(valid => {
        const body = {
          oracleCustomerId: this.order.data.oracleCustomerId,
          orderId: this.order.data.orderId,
          paymentId: this.order.data.paymentId
        };
        if (valid) {
          this.updateOrder(body);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    },
    getQr(type) {
      const body = {
        orderId: this.order.data.orderId,
        type: type
      };
      this.getQrCode(body);
    },
    handleClick(promoId) {
      // Handle the click event for the specific item
      window.open(`/promovoucher/edit/voucher/${promoId}`, '_blank');
      // You can perform any action you want here
    },
    calculateRowNumber(index) {
      const { currentPage, pageSize } = this.pagination;
      return (currentPage - 1) * pageSize + index + 1;
    },
    handleSizeChange(newSize) {
      this.pagination.pageSize = newSize;
      this.pagination.currentPage = 1;
      this.handlePagination('pageSize', newSize);
      this.handlePagination('page', 1);
      this.fetchData();
    },
    handlePageChange(newPage) {
      this.pagination.currentPage = newPage;
      this.handlePagination('page', newPage);
      this.fetchData();
    },
    handlePagination(name, newVal) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          [name]: newVal
        }
      })
    },
    fetchData() {
      const params = {
        oracleCustomerId: this.oracleCustomerId,
        orderId: this.orderId,
        page: this.$route.query.page || 1,
        pageSize: this.$route.query.pageSize || 10,
      };
      this.getOrder(params);
    },
  },
  watch: {
    qrCode: {
      handler(newValue) {
        if (!newValue.isLoading && !newValue.error) {
          this.blur = false;
          this.disabledBtnQr = true;
          if (newValue.data === "QR not available") {
            this.conditionQr = false;
          } else {
            this.conditionQr = true;
          }
          const self = this;
          setTimeout(() => {
            self.blur = true;
            self.conditionBtn = "reload";
            self.disabledBtnQr = false;
          }, 5000);
        }
      },
      deep: true
    }
  },
  created() {
    this.pagination.currentPage = +this.$route.query.page || 1;
    this.pagination.pageSize = +this.$route.query.pageSize || 10;
    this.fetchData();
    this.branch = process.env.VUE_APP_BRANCH
  }
};
</script>

<style>
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
.qrCodeNotAvailable {
  width: 350px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  font-weight: bold;
  margin-top: 10px;
}
</style>
